import { DUMMY_IMAGE } from "@/constants/dummy-image";

import type * as Shared from "../../../_shared";
import type * as Repository from "../../repository";

type Props = {
	queryData: Repository.Query.Type.QueryData;
};
type InputModel = Shared.Model.Type.FormModel["InputModel"];

export const serverModelToInputModelConverter = ({ queryData }: Props): InputModel => {
	const { voucherNewItem } = queryData;

	const inputModel: InputModel = {
		hotelID: voucherNewItem.hotelID,
		voucherID: voucherNewItem.voucherID,

		inSale: voucherNewItem.inSale,

		name: voucherNewItem.name,
		description: voucherNewItem.description,

		mainKeyVisual: DUMMY_IMAGE.s3Object,

		voucherPrice: voucherNewItem.voucherPrice,
		sellingPrice: voucherNewItem.sellingPrice,

		saleTypeForTerm: voucherNewItem.saleTypeForTerm,
		saleStart: voucherNewItem.saleStart || undefined,
		saleEnd: voucherNewItem.saleEnd || undefined,

		voucherLimitType: voucherNewItem.voucherLimitType,

		cinStart: voucherNewItem.cinStart || undefined,
		cinEnd: voucherNewItem.cinEnd || undefined,

		intervalPrepDates: voucherNewItem.intervalPrepDates,
		soldNumTotal: voucherNewItem.soldNumTotal,

		maxStockNum: voucherNewItem.maxStockNum,
	} satisfies InputModel;

	return inputModel;
};
